import { handleRawAssetCtaMessage } from "../clickthrough-overlay";
import {
  getPreviewersBaseUrl,
  getPreviewersOrigin,
} from "../previewer-static-base";

const _TREMACROS: {
  protocol: string;
  draft: string;
  lang?: string;
  [key: string]: string | undefined; // Add index signature
} = {
  protocol: window.location.protocol === "http" ? "http" : "https",
  draft: "false",
};

const _TRESETTINGS: {
  mraid: boolean;
  showLoadingIndicators: boolean;
  loadingImage: boolean;
  gameId?: string;
  gameVersion?: string;
  qa: boolean;
  madlib?: string;
} = {
  mraid: false,
  showLoadingIndicators: true,
  loadingImage: true,
  qa: false,
};

function insertScript(src: string, onLoad: () => void, onError: () => void) {
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.src = src;
  script.async = false;
  script.onload = onLoad;
  script.onerror = onError;
  head.appendChild(script);
}

const searchParams = new URLSearchParams(window.location.search);
const formatSize = searchParams.get("size");
const container = document.getElementById("tre_container");
if (container) {
  container.classList.add(formatSize || "fullscreen");
}
searchParams.delete("size");

/** Pull what we need from the querystring */
searchParams.forEach((value, key) => {
  /** Bring query string parameters to _TREMACROS. */
  _TREMACROS[key] = value;
});

const dst = searchParams.get("dst") || "B0149";
const placement = searchParams.get("placement");
const qaParam = searchParams.get("qa");
let creativeId = searchParams.get("creative");
console.log(`env: ${BUILD_ENV}`);

window.tre_products = [];

window.addEventListener("message", (event) => {
  if (event.origin !== window.location.origin) {
    return;
  }
  if (event.data.type === "PRODUCTS_DATA") {
    window.tre_products = event.data.products || [];
  }
});

_TRESETTINGS.qa =
  qaParam !== "false" && (BUILD_ENV === "development" || qaParam === "true");

const gameVersion =
  searchParams.get("version") || searchParams.get("gameversion");
if (gameVersion) _TRESETTINGS.gameVersion = gameVersion;

_TREMACROS.draft = searchParams.get("draft") || "false";

/**
 * Performs a synchronous XMLHttpRequest to the specified URL.
 *
 * @param {string} url - The URL to make the synchronous request to.
 * @throws {Error} Throws an error if the request fails or the status code is not 200.
 * @returns {string} The response text if the request is successful.
 */
const synchronousRequest = (url: string) => {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, false);
  xhr.send(null);
  if (xhr.status === 200) {
    return xhr.responseText;
  }
  throw new Error(`Request failed: ${xhr.statusText}`);
};

/** If creativeId is not present but placement is then try to pull the creativeId
 * from the placement.
 */
if (!creativeId && placement) {
  /** Pull creativeId from the API server */
  const placementEndpoint = `https://api${
    BUILD_ENV === "development" ? "-dev" : ""
  }.tresensa.com/placements/getCreativeId?placement=${placement}`;

  try {
    const response = JSON.parse(synchronousRequest(placementEndpoint));
    /** Set creativeId to the creative associated with the placement. */
    creativeId = response.creativeId;
  } catch (err) {
    console.error("Exception while pulling creative for placement", err);
  }
}

function launchAdContainer() {
  window._TREMACROS = _TREMACROS;
  window._TRESETTINGS = _TRESETTINGS;

  const scriptUrl = `https://${
    BUILD_ENV === "production" ? "sdk" : "sdk-dev"
  }.tresensa.com/adapters/${dst}/adcontainer.js`;

  insertScript(
    scriptUrl,
    () => {},
    () => {}
  );
}

const assetId = searchParams.get("asset");
if (assetId) {
  const type = searchParams.get("type") || "video";
  const file = searchParams.get("file");
  const isDev = searchParams.get("env") === "dev";
  const cdnBase = isDev
    ? "https://assets-dev.liftoff-genai.io"
    : "https://assets.liftoff-genai.io";
  const previewerBase = getPreviewersBaseUrl();

  let src: string;
  if (type === "html") {
    const htmlFile = file ? `${file}.html` : "index.html";
    src = `${cdnBase}/${assetId}/${htmlFile}`;
  } else {
    const params = new URLSearchParams({ id: assetId });
    if (type !== "video") params.set("format", type);
    if (file) params.set("file", file);
    params.set("base", cdnBase);
    src = `${previewerBase}/${type === "video" ? "video" : "image"}.html?${params.toString()}`;
  }

  const assetPreviewContainer = document.createElement("div");
  assetPreviewContainer.style.cssText =
    "position:fixed;top:0;left:0;width:100%;height:100%;margin:0;padding:0;overflow:hidden;";

  const iframe = document.createElement("iframe");
  iframe.src = src;
  iframe.style.cssText =
    "width:100%;height:100%;border:none;margin:0;padding:0;";
  assetPreviewContainer.appendChild(iframe);

  document.body.innerHTML = "";
  document.body.style.margin = "0";
  document.body.appendChild(assetPreviewContainer);

  const allowedOrigins = new Set<string>([
    new URL(cdnBase).origin,
    getPreviewersOrigin(),
  ]);
  if (BUILD_ENV === "development") {
    allowedOrigins.add(window.location.origin);
  }

  window.addEventListener("message", (event) => {
    handleRawAssetCtaMessage(event, iframe, allowedOrigins);
  });
} else if (!creativeId) {
  console.error("no creative ID provided");
} else {
  _TRESETTINGS.gameId = creativeId;

  /** If we don't have the version, then we need to get it from the root GameConfig.js */
  if (!_TRESETTINGS.gameVersion && _TREMACROS.draft !== "true") {
    const bucket = "games.tresensa.com";

    const gcUrl =
      `${_TREMACROS.protocol}://` +
      `${_TRESETTINGS.qa ? "qa-" : ""}` +
      `${bucket}/${creativeId}/GameConfig.js`;
    try {
      insertScript(
        gcUrl,
        function i() {
          // The root GameConfig was loaded
          _TRESETTINGS.gameVersion = window.GameConfig?.VERSION;
        },
        () => {
          // If an error happens while loading the GameConfig from the published bucket then set draft to "true".
          _TREMACROS.draft = "true";
        }
      );
    } finally {
      /** If we didn't get a GameConfig, it means the creative isn't published, force into draft mode */
      launchAdContainer();
    }
  } else {
    launchAdContainer();
  }
}
